import reducer from "./reducers";

export { default as magnetWorkSettingsOperations } from "./operations";
export { default as magnetWorkSettingsTypes } from "./types";

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/magnetWorkSettings/index.js